import { IThanhPhanMon } from "../../model/response/category/IThanhPhanMon";
import { apiClient } from "../apiClient";

export const THANH_PHAN_MON_API = "thanh-phan-mon";
export const thanhPhanMonApi = {
    SelectAll: () => apiClient.get(THANH_PHAN_MON_API),
    Insert: (payload: IThanhPhanMon) => apiClient.post(THANH_PHAN_MON_API, payload),
    Update: (id: number, payload: IThanhPhanMon) => apiClient.put(`${THANH_PHAN_MON_API}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${THANH_PHAN_MON_API}/${id}`),
}